import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { SharingDataService } from '../service/sharing-data.service';
// import { NgForm } from '@angular/forms';
// import { config } from '../config';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  data: any = {};
  public iconVisibility: boolean = false;
  submitMobile: any;
  otp: any;
  error: any;
  mobileNumber: any;
  name: any;
  email: any;
  _id: any;
  otpMobileEmail: string;
  returnUrl: string;
  interval: any;
  isSupervisor:boolean;
  loading:boolean;
  showTimer: any = '3:00';
  private onDestroy$: Subject<void> = new Subject<void>();
  public environment = environment;
  showBackBtn:Boolean=false

  constructor(private router: Router, public activatedRoute: ActivatedRoute, private serviceURLService: serviceURLService, private sharingDataService: SharingDataService) { }

  ngOnInit() {
    this.sharingDataService.returnUrl.subscribe(url => this.returnUrl = url);
    console.log(this.returnUrl);
    this.activatedRoute.queryParams.subscribe(params => {
      if(params.RedirectFromApp==="true"){
        this.showBackBtn=true
      }
      else{
        this.showBackBtn=false
      }
     
    })
  }

  keyPress(e: any) {
    //const pattern = /[0-9\+\-\ ]/;

    // let inputChar = String.fromCharCode(event.charCode);
    // if (event.keyCode != 8 && !pattern.test(inputChar)) {
    //   event.preventDefault();
    // }
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  startTimer() {
    this.showTimer = '3:00';
    this.interval = setInterval(() => {
      this.showTimer = this.showTimer.split(':');
      //by parsing integer, I avoid all extra string processing
      var minutes = parseInt(this.showTimer[0], 10);
      var seconds: any = parseInt(this.showTimer[1], 10);
      --seconds;
      minutes = (seconds < 0) ? --minutes : minutes;
      if (minutes < 0) clearInterval(this.interval);
      seconds = (seconds < 0) ? 59 : seconds;
      seconds = (seconds < 10) ? '0' + seconds : seconds;
      //minutes = (minutes < 10) ?  minutes : minutes;
      this.showTimer = minutes + ':' + seconds;
      if (this.showTimer === '0:00') {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  onSubmit() {
    this.loading=true
    // alert(JSON.stringify(this.data));
    this.data = {
      "mobile": this.data.mobile.toLowerCase(),
    }
    
    this.serviceURLService.submitMobileNumber(this.data).subscribe((successData: any) => {
     
      this.startTimer();
      let message=successData.message
      if(message=='You will shortly receive OTP via SMS.'){
        message="You will shortly receive OTP via SMS & Email."
      }

      document.getElementById("otpPartition").style.display = "block";
      document.getElementById("submitResponse").style.color = "#008000";
      document.getElementById("submitResponse").style.display = "block";
      document.getElementById("submitResponse").innerHTML = message ;
      if(message=="You will shortly receive OTP via SMS & Email."){
        setTimeout(() => {
          document.getElementById("submitResponse").style.display = "none";
          message=''
        }, 5000);
      }
      else{
      setTimeout(() => {
        document.getElementById("submitResponse").style.display = "none";
        message=''
      }, 20000);
    }
      document.getElementById("sendOTPButton").style.display = "none";
      this.mobileNumber = successData['response']['mobile']?successData['response']['mobile']:'';
      this.name = successData['response']['name'];
      this.email = successData['response']['email']?successData['response']['email']:'';
      this._id = successData['response']['_id'];
      this.isSupervisor=successData['response']['isSupervisor'];
      localStorage.setItem("mobileNumber", this.mobileNumber);
      localStorage.setItem("name", this.name);
      localStorage.setItem("email", this.email);
      localStorage.setItem("userID", this._id);
      localStorage.setItem("isSupervisor", JSON.stringify(this.isSupervisor));
      // Only mirror an explicit backend preference here. When the backend hasn't
      // decided yet (undefined), leave the flag unset so the in-app "enable
      // notifications?" prompt (app.component.ts) gets to ask the user first,
      // instead of silently defaulting to enabled.
      if(successData.response.isNotificationEnabled === true) {
        localStorage.setItem("isNotificationEnabled", "true");
      }else if(successData.response.isNotificationEnabled === false) {
        localStorage.setItem("isNotificationEnabled", "false");
      }
      if (successData.response.pamUserDetails.length) {
        let role = successData['response']['pamUserDetails'];
        localStorage.setItem('role', JSON.stringify(role[0]));
      }
      if(successData.response.saturdayOff || successData.response.sundayOff){
        localStorage.setItem("isDisplayAttendance", "true");
      }else {
        localStorage.setItem("isDisplayAttendance", "false");
      }
      localStorage.setItem("logOut", "2");
      //this.router.navigate(['otp']);
      // document.getElementById("otpPartition").style.display = "block";
      // document.getElementById("sendOTPButton").style.display = "none";
      this.loading=false
    }, (errorData) => {
      this.loading=false
      if (errorData.error.status === 401) {
        this.router.navigate(['registration']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        document.getElementById("submitResponse").style.display = "block";
        document.getElementById("submitResponse").style.color = "#FF0000";
        document.getElementById("submitResponse").innerHTML = this.error;
        setTimeout(() => {
          this.error = "";
          document.getElementById("submitResponse").style.display = "none";
        }, 20000);
      }
      else{
        document.getElementById("submitResponse").style.display = "block";
        document.getElementById("submitResponse").style.color = "#FF0000";
        document.getElementById("submitResponse").innerHTML = "Please wait,currently server is unavailable";
      }

      console.log("not registered");
    })

    this.getUserRole()

  }

  getUserRole(){


    this.data = {
      "mobile": this.data.mobile,
    }
    this.serviceURLService.getUserRole(this.data).subscribe((successData: any) => {
     
      if (successData.data.pamUserRole.length) {
        console.log("data_Save")
        let role_pam = successData['data'];
        localStorage.setItem('role_pam', JSON.stringify(role_pam));
      }       
    }, (errorData) => {
      if (errorData.error.status === 401) {
        this.router.navigate(['registration']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        setTimeout(() => {
          this.error = "";
        }, 3000);
      }  
       
      console.log("not registered");
    })
  }

  verifyOTPNumber() {
    this.loading=true
    this.otpMobileEmail = localStorage.getItem('mobileNumber')!=''?localStorage.getItem('mobileNumber'):localStorage.getItem('email');
    this.serviceURLService.verifyOTP(this.otpMobileEmail, this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      localStorage.setItem('authToken', JSON.stringify(successData.response.authToken));
      //this.router.navigate(['home']);
      if(localStorage.getItem('email')&&localStorage.getItem('mobileNumber')){

        var enToken = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('authToken').trim().slice(1).slice(0,-1))+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )
 
    var enEmail = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('email').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var enMobile = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('mobileNumber').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )
    
    var enId  = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('userID').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var enName  = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('name').trim().replace(/\s/g, '_'))+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var authData={
        $v3s6:enMobile,
        r$_dy:enEmail,
        x4$zl:enId,
        b_epqj:enToken,
        hj_5cy:enName
    }
    this.serviceURLService.verifyAuthTokenstatus(authData).subscribe((successData: any) => {
      const resStatus = atob(atob(successData.response.QZ_ipn).slice(10).slice(0,-10));
      //console.log(" resStatus ",resStatus)
      if(resStatus.toLowerCase()=='true'){
        this.router.navigateByUrl(this.returnUrl);
        this.returnUrl = '';   
      } else {
        localStorage.clear();
        this.router.navigate(['login']);
      }     
    }, errorData => {
      // localStorage.clear();
      // this.router.navigate(['login']);
    })
      } else {
        this.router.navigate(['complete-profile'])
      }
      localStorage.setItem("pamClientId" , successData.response.pamClientId);
      if (successData.response.isPolicyLaunch) {
        var LaunchFlag = successData.response.isPolicyLaunch;
        localStorage.setItem("companyName" , successData.response.completeUserData.company);

        if (LaunchFlag.length > 0) {
          if (LaunchFlag[0].isTrue === true) {
            localStorage.setItem("checkLaunchFlag", "true");
          }
        }
      }
      if (successData.response.firsttimeLogin) {
        let userData={
          "name":successData.response.name,
          "email":successData.response.email,
          "mobile":successData.response.mobile
        }
        this.serviceURLService.sendFirstLoginMail(userData).pipe(takeUntil(this.onDestroy$)).subscribe((sucess:any)=>{
          console.log("Welcome login mail sent successfully");
        }, err=>{
          this.loading=false
          console.log("Oops..!! error in send welcome login mail");
        })
      }
      //this.createProspect();
    }, errorData => {
      this.loading=false
      console.log("Oops..!! there is some error in OTP varification");
      if (errorData.error.status === 403) {
        //this.error = errorData.error.message;
        this.error = "Please enter correct OTP";
        setTimeout(() => {
          this.error = "";
        }, 3000);
      }
    })
  }
  // verifyOTPNumber() {
  //   console.log("m here")
  //   this.serviceURLService.verifyOTP(this.data, this.otp).subscribe(successData => {
  //     // this.login = successData
  //     console.log("m here2")
  //   }, errorData => {

  //   })
  // }

  termsModalPopup() {
    $("#termsModal").modal("show");
  }

  backFunction(){
    window.history.back()
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
  
}
